import { Translation } from '../types';

export const es: Translation = {
  common: {
    loading: 'Cargando...',
    error: 'Error',
    cancel: 'Cancelar',
    save: 'Guardar',
    close: 'Cerrar',
    search: 'Buscar',
    reload: 'Recargar',
    logout: 'Cerrar sesión',
    dashboard: 'Panel de control',
    products: 'Productos',
    settings: 'Configuración',
    language: 'Idioma',
    businessHours: 'Horario comercial',
    back: 'Volver',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar todo',
    success: 'Éxito',
    selected: 'seleccionados',
    confirm: 'Confirmar',
    required: 'Requerido',
    requiredMarker: '*',
    previous: 'Anterior',
    next: 'Siguiente',
    allRightsReserved: 'Todos los derechos reservados.',
  },
  auth: {
    login: 'Iniciar sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    loginButton: 'Iniciar sesión',
    loggingIn: 'Iniciando sesión...',
    loginSuccess: 'Inicio de sesión exitoso',
    loginError: 'Correo o contraseña incorrectos',
    invalidEmail: 'Ingrese un correo válido',
    requiredFields: 'Complete todos los campos',
    demoAccount: 'Cuenta demo:',
    loginDescription: 'Acceda a su cuenta',
    welcomeMessage: 'Bienvenido a su espacio profesional',
    // Registration
    register: 'Registrarse',
    createAccount: 'Crear cuenta',
    confirmPassword: 'Confirmar contraseña',
    passwordRequirements: 'Mín. 8 caracteres: mayúsculas, minúsculas, números y símbolos',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    registrationSuccess: 'Registro exitoso',
    registrationDescription: 'Cree su cuenta profesional',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    signIn: 'Iniciar sesión',
    dontHaveAccount: '¿No tienes una cuenta?',
    creatingAccount: 'Creando cuenta...',
    registrationNote: 'Nota:',
    registrationNotePoints: {
      erpLinking: 'Si tienes una cuenta comercial existente, tu correo electrónico se vinculará automáticamente',
      companyEmail: 'Por favor, usa tu dirección de correo electrónico corporativo para el registro',
      contactSupport: 'Contáctanos si necesitas ayuda con el registro'
    },
    b2bUsers: 'Clientes profesionales:',
    registeredEmail: 'Correo registrado',
    registeredPassword: 'Contraseña creada al registrarse',
    b2bCustomerRequired: 'Correo no reconocido. Contacte a ventas para abrir una cuenta profesional.',
    b2bVerificationError: 'Error de verificación. Contacte soporte.',
    // Password Reset
    passwordReset: 'Restablecimiento de contraseña',
    passwordResetDescription: 'Reciba una contraseña temporal por correo',
    getTemporaryPassword: 'Obtener contraseña temporal',
    processing: 'Procesando...',
    passwordResetComplete: 'Restablecimiento de contraseña completado',
    temporaryPasswordGenerated: 'Contraseña temporal generada',
    temporaryPassword: 'Contraseña temporal',
    backToLogin: 'Volver',
    securityNotice: 'Aviso de seguridad:',
    securityNotePoints: {
      keepSecret: 'Mantenga esta contraseña confidencial',
      changeAfterLogin: 'Cámbiela tras iniciar sesión',
      expires24Hours: 'Válida por 24 horas'
    },
    resetNote: 'Nota:',
    resetNotePoints: {
      registeredEmail: 'Use su correo profesional',
      passwordDisplayed: 'La contraseña aparecerá aquí',
      changeRequired: 'Cambio obligatorio al primer acceso'
    },
    copied: 'Copiado',
    copySuccessMessage: '¡Contraseña copiada!',
    forgotPassword: '¿Olvidaste tu contraseña?',
    // Password Reset Email Request
    sendResetLink: 'Enviar enlace',
    sendingEmail: 'Enviando...',
    emailSent: 'Correo enviado',
    emailSentMessage: 'Si el correo está registrado, recibirá un enlace de restablecimiento.',
    emailNotSent: 'Correo no enviado',
    emailSentInfo: 'Revise su correo (y spam)',
    checkEmail: 'Revisar correo',
    emailInstructions: 'Instrucciones enviadas por correo',
    nextSteps: 'Próximos pasos:',
    nextStepsList: {
      checkInbox: 'Revise su correo y spam',
      clickLink: 'Haga clic en el enlace recibido',
      linkExpires: 'Válido por 24h',
      contactSupport: '¿No lo recibió? Contacte soporte',
      rateLimitInfo: 'Máx. 3 solicitudes/hora'
    },
    // Password Reset Completion
    resetLinkSent: 'Enlace de restablecimiento enviado',
    resetSuccess: 'Contraseña restablecida con éxito',
    passwordUpdated: 'Contraseña actualizada',
    passwordUpdateMessage: 'Contraseña actualizada. Puede iniciar sesión.',
    loginWithNewPassword: 'Iniciar sesión',
    // Reset Token Page
    resetToken: 'Restablecer contraseña',
    invalidToken: 'Enlace inválido',
    expiredToken: 'Enlace expirado',
    tokenValid: 'Enlace válido',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    updatePassword: 'Actualizar',
    updatingPassword: 'Actualizando...',
    passwordMismatch: 'Las contraseñas no coinciden',
    resetInstructions: 'Elija su nueva contraseña',
  },
  accountInfo: {
    title: 'Información de la cuenta',
    loading: 'Cargando...',
    error: 'Error',
    errorMessage: 'No se pudo cargar la información',
    back: 'Volver',
    basicInfo: 'Información básica',
    name: 'Nombre',
    email: 'Correo electrónico',
    contactId: 'ID de Cliente Knitido',
    contactNumber: 'Número de contacto',
    noInfo: 'No disponible',
    companyInfo: 'Empresa',
    company: 'Empresa',
    position: 'Cargo',
    vatId: 'NIF/CIF',
    billingAddress: 'Dirección de facturación',
    deliveryAddress: 'Dirección de entrega',
    addressInfo: 'Direcciones',
    billingDescription: 'Para facturas y contratos',
    deliveryDescription: 'Para envíos de productos',
    sameAsBilling: '※ Misma que facturación',
    sameAsDelivery: '※ Misma que entrega',
    companyName: 'Nombre de la empresa',
    contactPerson: 'Persona de contacto',
    address: 'Dirección',
    phoneNumber: 'Número de teléfono',
    billingUsage: 'Para facturas y documentos oficiales',
    deliveryUsage: 'Para entrega de pedidos',
    alsoUsedForDelivery: 'También para entregas',
    accountType: 'Tipo de cuenta',
    addressId: 'ID de dirección',
    // Address editing functionality
    edit: 'Editar',
    editDeliveryAddress: 'Editar dirección de entrega',
    editDeliveryDescription: 'Modifique su dirección de entrega',
    newDeliveryAddress: 'Agregar nueva dirección de entrega',
    newDeliveryDescription: 'Ingrese los detalles de su nueva dirección de entrega',
    noDeliveryAddress: 'No hay dirección de entrega configurada',
    success: 'Éxito',
    addressUpdated: 'Dirección actualizada',
    updateError: 'Error al actualizar',
    requiredFields: 'Complete todos los campos requeridos',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    streetAddress: 'Calle y número',
    streetAddress2: 'Complemento',
    city: 'Ciudad',
    country: 'País',
    selectCountry: 'Seleccionar país...',
    searchCountry: 'Buscar país...',
    noCountryFound: 'No se encontró ningún país.',
    postalCode: 'Código postal',
    companyNamePlaceholder: 'Nombre de empresa',
    firstNamePlaceholder: 'Nombre',
    lastNamePlaceholder: 'Apellido',
    streetAddressPlaceholder: 'Calle y número',
    streetAddress2Placeholder: 'Piso, depto. (opcional)',
    cityPlaceholder: 'Ciudad',
    postalCodePlaceholder: 'Código postal',
    billingNotEditable: 'Dirección de facturación no editable.',
    billingContactSupport: 'Contacte soporte para modificar.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} direcciones de envío',
    noDeliveryAddresses: 'No hay direcciones de envío registradas',
    defaultAddress: 'Predeterminado',
    selectDeliveryAddress: 'Seleccionar dirección de envío',
    addNewAddress: 'Agregar nueva dirección',
    editAddress: 'Editar dirección',
    deleteAddress: 'Eliminar dirección',
    confirmDelete: 'Confirmar eliminación',
    confirmDeleteMessage: '¿Está seguro de que desea eliminar esta dirección? Esta acción no se puede deshacer.',
    addressAddedSuccess: 'Dirección de envío agregada',
    addressDeletedSuccess: 'Dirección de envío eliminada',
    deleteError: 'Error al eliminar la dirección de envío',
    saving: 'Guardando...',
    cancel: 'Cancelar',
    saveChanges: 'Guardar cambios',
    selectedDeliveryAddress: 'Dirección de envío seleccionada',
  },
  dashboard: {
    title: 'Socio comercial',
    subtitle: 'Sistema de pedidos de productos',
    welcome: 'Bienvenido,',
    welcomeMessage: '¡Bienvenido! Realice sus pedidos de forma sencilla.',
    productCatalog: 'Catálogo de productos',
    productCatalogDesc: 'Explore y pida nuestros productos',
    viewProducts: 'Ver productos',
    orderHistory: 'Historial de pedidos',
    orderHistoryDesc: 'Consulte sus pedidos anteriores',
    accountSettings: 'Configuración de cuenta',
    accountSettingsDesc: 'Gestione su información',
    comingSoon: 'Pronto',
    infoTitle: 'Ayuda',
    orderingInfo: 'Pedido de productos',
    orderingDesc: 'Elija productos, tallas y colores. Stock en tiempo real.',
    supportInfo: 'Soporte',
    supportDesc: '¿Preguntas? Contáctenos.',
    viewOrderHistory: 'Historial',
    viewOrders: 'Mis pedidos',
    accountInfo: 'Información de la cuenta',
    accountInfoDesc: 'Consulte su información',
    viewDetails: 'Detalles',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Lun-Vie 9h-15h CET',
    bulkImportDesc: 'Importar pedidos desde archivos Excel/CSV',
    importOrders: 'Importar pedidos',
  },
  products: {
    title: 'Lista de productos',
    subtitle: 'Socio comercial',
    searchPlaceholder: 'Nombre o SKU del producto...',
    productId: 'ID de producto',
    addToCart: 'Agregar al carrito',
    selectVariation: 'Elegir variante',
    price: 'Precio',
    priceNetNotice: 'Precios sin impuestos',
    stock: 'Inventario',
    color: 'Color',
    newProducts: 'Nuevos Productos',
    newProductBadge: 'NUEVO',
    size: 'Talla',
    quantity: 'Cantidad',
    total: 'Total',
    cart: 'Carrito',
    checkout: 'Finalizar compra',
    csvMode: 'Modo rápido CSV',
    csvInfo: 'Datos del archivo CSV',
    csvUploadDate: 'Importado:',
    stockNote: '※ Stock actualizado al seleccionar variante',
    noProducts: 'No se encontraron productos',
    noProductsDesc: 'Modifique su búsqueda o importe un archivo CSV.',
    retry: 'Reintentar',
    pagination: 'artículos',
    variations: 'variaciones',
    stockFetchError: 'Error de stock',
    stockFetchFailed: 'Stock no disponible',
    stockFetchFailedDesc: 'Stock no disponible. Mostrando datos CSV.',
    stockFetched: 'Stock actualizado',
    totalStock: 'Inventario total',
    noStockAll: 'Sin stock disponible',
    noStockData: 'Sin datos de stock',
    stockFetchErrorDesc: 'Error al obtener el stock',
    selectionError: 'Selección incorrecta',
    enterQuantity: 'Cantidad requerida',
    addedToCart: '¡Agregado!',
    typesAdded: ' productos agregados',
    addToCartError: 'Error al añadir al carrito',
    addToCartErrorDesc: 'Por favor, inténtelo de nuevo',
    loadingStock: 'Verificando stock...',
    csvDataInfo: 'Datos CSV (stock no actualizado)',
    filterByCategory: 'Filtrar por categoría',
    allProducts: 'Todos los productos',
    applyFilters: 'Aplicar filtros',
    clearFilters: 'Borrar filtros',
    filters: 'Filtros',
    clearAll: 'Borrar todo',
    invalidDataFormat: 'Formato de datos inválido',
    loadFailed: 'Error de carga',
    csvUploadComplete: 'Importación completada',
    csvLoadedDesc: ' productos importados. Stock actualizado al seleccionar.',
    searchTitle: 'Búsqueda de productos',
    loadingProducts: 'Cargando productos...',
    noProductsCsv: 'Sin productos en el CSV. Modifique su búsqueda.',
    paginationDisplay: ' mostrados',
    previous: 'Anterior',
    next: 'Siguiente',
    selectionSummary: 'Resumen',
    selectedQuantity: 'Cantidad seleccionada',
    items: ' artículos',
    viewDetails: 'Detalles',
    productImage: 'Imagen del producto',
    correspondingVariations: 'Variantes disponibles',
    clickToEnlarge: 'Ampliar',
    productIdLabel: 'ID de producto',
    colorLabel: 'Color',
  },
  productDetail: {
    title: 'Detalles del producto',
    backToProducts: 'Volver a productos',
    productNotFound: 'Producto no encontrado',
    productNotFoundDesc: 'Producto no encontrado o eliminado.',
    loading: 'Cargando...',
    imageLoadError: 'Imágenes no disponibles',
    noImages: 'No hay imágenes disponibles',
    productDescription: 'Descripción del producto',
    colors: 'Colores',
    sizes: 'Tallas',
    colorCount: 'colores',
    sizeCount: 'tallas',
    variationCount: 'variaciones',
    selectVariation: 'Elegir variantes',
    descriptionLanguageNote: '※ Descripciones en inglés/alemán',
  },
  colors: {
    schwarz: 'Negro',
    weiß: 'Blanco',
    grau: 'Gris',
    rot: 'Rojo',
    blau: 'Azul',
    grün: 'Verde',
    gelb: 'Amarillo',
    rosa: 'Rosa',
    lila: 'Púrpura',
    braun: 'Marrón',
    orange: 'Naranja',
    beige: 'Beige',
    navy: 'Azul marino',
    dunkelblau: 'Azul oscuro',
    hellblau: 'Azul claro',
    dunkelgrau: 'Gris oscuro',
    hellgrau: 'Gris claro',
    bordeaux: 'Burdeos',
    türkis: 'Turquesa',
    khaki: 'Caqui',
    mint: 'Menta',
    violett: 'Violeta',
    anthrazit: 'Antracita',
    blaugrau: 'Gris azulado',
    burgunderrot: 'Borgoña',
    elfenbein: 'Marfil',
    karminrot: 'Carmín',
    neongrün: 'Verde neón',
    gelbgrün: 'Verde amarillo',
    pistazie: 'Pistacho',
    // Nombres de colores en inglés (usados en Product ID 237, etc.)
    blue: 'Azul',
    ivory: 'Marfil',
    green: 'Verde',
    gold: 'Oro',
    red: 'Rojo',
  },
  categories: {
    category_21: 'Accesorios',
    category_23: 'Calcetines básicos',
    category_24: 'Ofertas',
    category_29: 'B2B'
  },
  checkout: {
    title: 'Pago',
    cartReview: 'Revisar pedido',
    orderSummary: 'Resumen',
    shippingInfo: 'Información de envío',
    billingInfo: 'Información de facturación',
    orderNotes: 'Notas del pedido',
    orderNotesPlaceholder: 'Notas o solicitudes especiales...',
    contactPerson: 'Persona de contacto',
    phoneNumber: 'Número de teléfono',
    email: 'Correo',
    company: 'Empresa',
    address: 'Dirección',
    city: 'Ciudad',
    postalCode: 'Código postal',
    country: 'País',
    deliveryDate: 'Fecha de entrega',
    urgentDelivery: 'Entrega express (3-5 días hábiles)',
    standardDelivery: 'Entrega estándar (7-10 días hábiles)',
    placeOrder: 'Realizar pedido',
    backToCart: 'Volver al carrito',
    requiredField: 'Campo obligatorio',
    orderTotal: 'Total del pedido',
    subtotal: 'Subtotal',
    priceNetNotice: 'Precios sin impuestos',
    stockReservationNotice: 'Stock reservado tras confirmación.',
    stockCheckError: 'Error de stock',
    stockCheckErrorDesc: 'Verificación fallida. Inténtelo de nuevo.',
    shipping: 'Envío',
    shippingCost: 'Envío',
    tax: 'Impuesto',
    orderSuccess: 'Pedido exitoso',
    orderSuccessMessage: 'Su pedido ha sido enviado correctamente. Número de pedido: {orderNumber}',
    orderNumber: 'Número de pedido',
    thankYou: '¡Gracias por su pedido!',
    orderConfirmation: '¡Pedido enviado!',
    orderProcessing: 'Confirmación por correo tras validación.',
    orderProcessingMessage: 'Pedido enviado. Confirmación por correo tras validación.',
    continueShopping: 'Continuar comprando',
    emptyCart: 'Tu carrito está vacío',
    emptyCartMessage: 'Por favor, añade productos a tu carrito para continuar',
    stockWarning: 'Advertencia de stock',
    stockWarningDesc: 'Stock insuficiente. Ajuste cantidades.',
    stockError: 'Error de stock',
    stockErrorDesc: 'Stock insuficiente. Modifique cantidades.',
    refreshStock: 'Actualizar stock',
    stockUpdated: 'Stock actualizado',
    stockUpdatedDesc: 'Stock actualizado - {changed} cambios',
    stockCheckDesc: 'Verificación de stock completada',
    stockOk: 'Stock OK',
    stockShortage: 'Escasez de stock',
    requestedQty: 'Cant. solicitada',
    currentStock: 'Stock actual',
    stockShortageMsg: 'Stock insuficiente. Modifique cantidad.',
    stockIssueWarning: 'Pedido imposible - stock insuficiente.',
    stockDataMissing: 'Verificando stock...',
    outOfStock: 'Agotado.',
    maxAvailable: 'Máximo',
    autoRestored: 'Carrito restaurado',
    autoRestoredDesc: 'Se han restaurado los artículos de su última sesión',
    maxQuantityReached: 'Cantidad máxima alcanzada.',
    // ERP Contact Search
    contactSearch: 'Búsqueda de contacto del cliente',
    contactSearchDesc: 'Ingrese el correo del cliente',
    emailAddress: 'Dirección de correo',
    searchButton: 'Buscar',
    searching: 'Buscando...',
    contactFound: 'Contacto encontrado',
    contactNotFound: 'Contacto no encontrado',
    contactId: 'ID de Cliente Knitido',
    companyName: 'Empresa',
    contactPersonLabel: 'Persona de contacto',
    addressesFound: 'Direcciones encontradas',
    addressType: 'Tipo',
    addressBilling: 'Dirección de facturación',
    addressDelivery: 'Dirección de entrega',
    vatSourceCompany: 'Info empresa',
    vatSourceBilling: 'Facturación',
    vatSourceDelivery: 'Entrega',
    addressOther: 'Otro',
    addressDetails: 'Dirección',
    loadingAddresses: 'Cargando información de direcciones...',
    addressRetrieved: 'Información de dirección recuperada',
    addressNotFound: 'Información de dirección no encontrada',
    addressNotFoundDesc: 'Dirección no encontrada. Ingrese manualmente.',
    addressError: 'Error de dirección',
    addressErrorDesc: 'No se pudo cargar la dirección.',
    contactNotConfirmed: 'Contacto del cliente no confirmado',
    contactNotConfirmedDesc: 'Busque primero el contacto del cliente.',
    searchContact: 'Buscar contacto',
    inputError: 'Error de entrada',
    inputErrorDesc: 'Información incompleta.',
    processing: 'Procesando...',
    erpContactSearch: 'Búsqueda de contacto del cliente',
    contactSearchError: 'Correo no reconocido.',
    // Product Images Toggle
    showProductImages: 'Mostrar imágenes de productos',
    showProductImagesDesc: 'Mostrar fotos de productos (carga más lenta)',
    // System Registration Info
    systemRegistrationInfo: 'Su información de cliente',
    editShippingAddress: 'Editar dirección de entrega',
    systemRegistrationInfoDesc: 'Sus datos empresariales. Para modificar facturación, contacte a su representante.',
    // Order Summary
    regularPrice: 'Precio mayorista regular',
    offeredPrice: 'Precio ofrecido',
    discount: 'Descuento',
    b2bCustomer: 'Cliente B2B',
    pattern: 'Patrón',
    specialPriceApplied: 'Precio especial aplicado',
    customerClassification: 'Clasificación de cliente',
    paymentCondition: 'Condiciones de pago',
    invoice: 'Factura (NET 30)',
    prepayment: 'Pago anticipado',
    paymentMethod: 'Método de pago',
    invoicePayment: 'Pago por factura',
    estimatedSubtotal: 'Subtotal estimado',
    estimatedTotal: 'Total estimado',
    orderSummaryDisclaimer: 'Precios estimados. Confirmación final con precios, envío e impuestos por correo.',
    searchError: 'Error de búsqueda',
    searchErrorDesc: 'Error de búsqueda.',
    confirmDeleteItem: 'Eliminar artículo',
    itemDeleted: 'Artículo eliminado',
    confirmDeleteItemDesc: '¿Eliminar este artículo del carrito?',
    deleteConfirm: 'Eliminar',
    contactNotes: 'Notas de contacto',
    contactNotesDesc: '¿Preguntas o solicitudes especiales? (opcional)',
    contactNotesLabel: 'Mensaje',
    contactNotesPlaceholder: 'Ej: preguntas sobre productos, requisitos especiales...',
    characters: 'caracteres',
    contactIdLabel: 'ID de Cliente Knitido',
    companyLabel: 'Empresa',
    personLabel: 'Persona de contacto',
    emailLabel: 'Correo',
    addressTypeLabel: 'Tipo',
    destinationLabel: 'Destino',
    // Shipping Form
    shippingTitle: 'Información de envío',
    shippingDesc: '¿Dónde entregar sus productos?',
    companyRequired: 'Empresa *',
    contactPersonRequired: 'Persona de contacto *',
    emailRequired: 'Dirección de correo *',
    phoneRequired: 'Número de teléfono *',
    addressRequired: 'Dirección 1 *',
    address2: 'Complemento (Edif./Depto.)',
    postalCodeRequired: 'Código postal *',
    cityRequired: 'Ciudad *',
    countryRequired: 'País *',
    selectCountry: 'Elegir país',
    shippingMethodRequired: 'Envío *',
    selectShippingMethod: 'Elegir envío',
    urgentDeliveryOption: 'Express (cargo adicional)',
    deliveryNotes: 'Notas de entrega',
    deliveryNotesPlaceholder: 'Preferencias de entrega...',
    standardShipping: 'Envío estándar (3-5 días hábiles)',
    expressShipping: 'Envío express (1-2 días hábiles)',
    overnightShipping: 'Envío nocturno',
    germany: 'Alemania',
    austria: 'Austria',
    switzerland: 'Suiza',
    japan: 'Japón',
    shippingAddressLabel: 'Dirección de entrega',
    changeDeliveryAddress: 'Cambiar dirección de entrega',
    selectDeliveryAddress: 'Seleccionar dirección de entrega',
    // Shipping Cost Details
    freeShipping: 'Envío gratuito',
    shippingError: 'Error',
    shippingZone: 'Zona de envío',
    remainingForFreeShipping: '{amount} más para envío gratuito',
    moreForFreeShipping: 'para envío gratuito',
    freeShippingProgress: 'Envío gratuito en',
    andAboveFreeShipping: 'y más para envío gratuito',
    freeShippingAchieved: 'Envío gratuito aplicado',
    threshold: 'y más',
    nextShippingTier: 'Siguiente descuento de envío',
    moreForDiscount: 'más para',
    shippingSavings: 'ahorro en envío',
    orderAmountThreshold: 'y más para',
    specialRegionNotice: 'Región de envío especial aplicada',
    defaultShippingApplied: 'Tarifas de envío estándar aplicadas',
    requestedQuantity: 'Cantidad solicitada',
    availableQuantity: 'Cantidad disponible',
    orderSubmitError: 'Error al enviar pedido',
    orderSubmitErrorDesc: 'No se pudo enviar el pedido',
    upload: {
      title: 'Importar pedido Excel/CSV',
      description: 'Sube un archivo Excel o CSV con los datos de tu pedido',
      dragDropOrClick: 'Arrastra y suelta el archivo aquí o haz clic para seleccionar',
      dropHere: 'Suelta el archivo aquí',
      supportedFormats: 'Formatos compatibles: Excel (.xlsx, .xls) y CSV (.csv)',
      maxSize: 'Tamaño máximo del archivo: {size} MB',
      processFile: 'Procesar archivo',
      processing: 'Procesando archivo...',
      ready: 'Archivo listo para vista previa',
      readyDescription: 'Tu archivo se ha procesado correctamente y está listo para revisar.',
      preview: 'Mostrar vista previa',
      errors: {
        fileTooLarge: 'El archivo es demasiado grande. Tamaño máximo: {size} MB',
        invalidFileType: 'Tipo de archivo no válido. Por favor, sube un archivo Excel o CSV',
        uploadFailed: 'Error al cargar el archivo',
      },
    },
    // Loading messages
    loadingPage: 'Cargando...',
    loadingStock: 'Verificando stock...',
    loadingAccount: 'Cargando cuenta...',
    loadingError: 'Error de carga',
    loadingData: 'Cargando datos',
    // Toast messages
    addressRetrievedTitle: 'Dirección encontrada',
    addressSetAsDelivery: ' será la dirección de entrega.',
    contactFoundDesc: ' identificado.'
  },
  orderHistory: {
    title: 'Historial de pedidos',
    searchPlaceholder: 'N° de pedido o SKU...',
    noOrders: 'No se encontraron pedidos',
    noOrdersFound: 'Sin resultados',
    startShopping: 'Ver productos',
    orderItems: 'Artículos del pedido',
    viewDetails: 'Detalles',
    reorder: 'Volver a pedir',
    orderDate: 'Fecha del pedido',
    orderStatus: 'Estado',
    orderTotal: 'Total del pedido',
    // Status translations
    statusPending: 'Pago pendiente',
    statusProcessing: 'Procesando',
    statusConfirmed: 'Confirmado',
    statusShipped: 'Enviado',
    statusDelivered: 'Entregado',
    statusCancelled: 'Cancelado',
    statusReturned: 'Devuelto',
    statusRefunded: 'Reembolsado',
    statusWarranty: 'En garantía',
    statusExchanged: 'Intercambiado',
    statusRepair: 'En reparación',
    statusUnknown: 'Desconocido',
    statusIncomplete: 'Incompleto',
    statusWaitingPayment: 'Esperando pago',
    statusInPreparation: 'En preparación',
    statusClearedShipping: 'Listo para envío',
    statusBeingShipped: 'En proceso de envío',
    statusOutgoingBooked: 'Envío reservado',
    statusReturn: 'Devolución',
    // Additional UI elements
    itemCount: 'artículos',
    itemCountSingular: 'artículo',
    refreshButton: 'Actualizar',
    errorFetchingOrders: 'Error al cargar historial',
    // Payment status features
    paymentStatus: 'Estado de pago',
    markAsPaid: 'Marcar como pagado',
    unmarkAsPaid: 'Desmarcar como pagado',
    paidOn: 'Pagado el',
    paymentMarked: 'Pagado',
    notPaid: 'No pagado',
    paymentMarkedSuccess: 'Marcado como pagado',
    paymentUnmarkedSuccess: 'Desmarcado como pagado',
    paymentUpdateError: 'Error al actualizar el estado de pago',
    // Payment date dialog
    paymentDateTitle: 'Ingresar información de pago',
    paymentDateDescription: 'Ingrese la información de pago para el pedido {orderNumber}',
    paymentDateLabel: 'Fecha de pago',
    selectDate: 'Seleccionar fecha',
    paymentDateHelp: 'Seleccione la fecha de la transferencia bancaria',
    paymentMethodLabel: 'Método de pago',
    bankTransfer: 'Transferencia bancaria',
    invoice: 'Factura',
    otherPayment: 'Otro',
    paymentReferenceLabel: 'Referencia de pago',
    paymentReferencePlaceholder: 'ej. Transferencia del 01/01/2024',
    paymentReferenceHelp: 'Ingrese información que ayude a la conciliación',
    notesLabel: 'Notas',
    notesPlaceholder: 'Información adicional sobre el pago',
    // Filter options
    filterByPaymentStatus: 'Filtrar por estado de pago',
    allOrders: 'Todos los pedidos',
    paidOrders: 'Pagados',
    unpaidOrders: 'No pagados',
    // Sorting options
    sortBy: 'Ordenar por',
    sortByDate: 'Fecha de pedido',
    sortByPaymentDate: 'Fecha de pago',
    sortByAmount: 'Monto',
    sortByStatus: 'Estado',
  },
  orderDetails: {
    title: 'Detalles del pedido',
    notFound: 'Pedido no encontrado',
    backToHistory: 'Volver al historial',
    orderDate: 'Fecha del pedido',
    orderItems: 'Artículos del pedido',
    deliveryStatus: 'Estado de entrega',
    estimatedDelivery: 'Entrega estimada',
    deliveredOn: 'Entregado el',
    downloadInvoice: 'Descargar factura',
    statusDelivered: 'Entregado',
    statusShipped: 'Enviado',
    statusConfirmed: 'Confirmado',
    statusCancelled: 'Cancelado',
    errorFetchingDetails: 'Error al cargar detalles',
  },
  company: {
    name: 'Socio comercial',
    tagline: 'Plataforma profesional',
    copyright: '© 2025 Knitido. Todos los derechos reservados.',
  },
  footer: {
    phone: 'Teléfono',
    email: 'Correo',
    countries: {
      DE: 'Alemania',
      AT: 'Austria',
      CH: 'Suiza',
      FR: 'Francia',
      IT: 'Italia',
      ES: 'España',
      NL: 'Países Bajos',
      BE: 'Bélgica',
      PL: 'Polonia',
      SE: 'Suecia',
      NO: 'Noruega',
      FI: 'Finlandia',
      DK: 'Dinamarca',
      LT: 'Lituania',
      LV: 'Letonia',
      EE: 'Estonia',
    },
  },
  cart: {
    newCart: 'Nuevo carrito',
    currentCart: 'Carrito actual',
    modified: 'modificado',
    lastSaved: 'Último guardado',
    unsavedChanges: 'sin guardar',
    saveCart: 'Guardar carrito',
    loadCart: 'Cargar carrito',
    deleteCart: 'Eliminar carrito',
    startNewCart: 'Iniciar nuevo carrito',
    savedCarts: 'Carritos guardados',
    cartSaved: 'Carrito guardado',
    cartDeleted: 'Carrito eliminado',
    confirmDeleteCart: '¿Eliminar este carrito?\n\nAcción irreversible.',
    confirmSwitchCart: 'Carrito sin guardar.\n\nLos cambios se perderán.\n\n¿Continuar?',
    confirmSwitchCartTitle: 'Cambiar carrito',
    confirmNewCart: 'Carrito sin guardar.\n\nLos cambios se perderán.\n\n¿Continuar?',
    confirmNewCartTitle: 'Iniciar nuevo carrito',
    confirmClearCart: '¿Vaciar carrito?\n\n{count} artículos eliminados.\n\nAcción irreversible.',
    confirmClearCartTitle: 'Vaciar carrito',
    autoSaved: 'Guardado automático',
    itemsWillBeRemoved: 'artículos eliminados',
    changesWillBeLost: 'cambios perdidos',
    continueQuestion: '¿Continuar?',
    cartStatus: 'Estado del carrito',
    cartName: 'Nombre del carrito',
    cartNamePlaceholder: 'Ej: Pedido marzo 2025',
    cartNameRequired: 'Nombre requerido',
    saveCartDescription: 'Nombre y guarde este carrito para después.',
    cancelCart: 'Cancelar carrito',
    proceedToCheckout: 'Proceder al pago',
    emptyCart: 'El carrito está vacío',
    erpDown: 'El sistema de pedidos está caído. Por favor, inténtelo de nuevo más tarde.',
    erpDegraded: 'El sistema está actualmente inestable. Los pedidos pueden fallar.',
    erpDownSaveHint: 'Guarde su carrito y realice su pedido cuando el sistema se restablezca.',
    erpSaveCart: 'Guardar carrito',
  },
  nav: {
    dashboard: 'Inicio',
    products: 'Productos',
    orderHistory: 'Mis pedidos',
    account: 'Mi cuenta',
    bulkImport: 'Importación masiva',
  },
  settings: {
    selectLanguage: 'Elegir idioma',
    languagePreferenceSaved: 'Idioma guardado para próximas visitas.',
  },
  reorder: {
    allItemsAdded: '{count} artículos añadidos al carrito',
    partialSuccess: '{added} artículos añadidos. {failed} artículos no se pudieron añadir',
    allItemsFailed: 'No se pudieron añadir los artículos al carrito',
    error: 'Se produjo un error al realizar el nuevo pedido',
    itemDiscontinued: '{name} ({color}/{size}) ha sido descontinuado',
    itemOutOfStock: '{name} ({color}/{size}) está agotado',
    partialStock: '{name} ({color}/{size}) solo {available} disponibles',
    confirmReorder: 'Confirmar nuevo pedido',
    confirmReorderMessage: '¿Añadir los artículos de este pedido a su carrito?',
    addingToCart: 'Añadiendo al carrito...',
    checkingStock: 'Verificando disponibilidad...',
    checkoutTitle: 'Artículos añadidos al carrito',
    checkoutDescription: '{count} artículos añadidos al carrito. ¿Desea proceder al pago?',
  },
  bulkImport: {
    instructions: 'Cómo importar pedidos',
    step1: 'Descargue el archivo de plantilla de pedido',
    step2: 'Complete los datos con SKU y cantidad',
    step3: 'Guarde como archivo Excel (.xlsx) o CSV',
    step4: 'Suba el archivo usando el formulario a continuación',
    step5: 'Revise y confirme su pedido',
    downloadTemplate: 'Descargar plantilla',
    formatGuide: 'Guía de formato de archivo',
    requiredColumns: 'Columnas obligatorias',
    skuDescription: 'Código SKU del producto',
    quantityDescription: 'Cantidad a pedir (número entero positivo)',
    optionalColumns: 'Columnas opcionales',
    notesDescription: 'Notas internas (ej: n° PO, referencias) - solo para sus registros propios',
    formatNote: 'La primera fila debe contener los encabezados de columna. Los datos comienzan desde la segunda fila.',
    parseSuccess: 'Se procesaron exitosamente {count} artículos del archivo',
    parseError: 'Error de procesamiento',
    validationError: 'Errores de validación',
    validationErrorGuidance: 'Por favor, haga clic en el botón «{showPreviewButton}» para revisar los detalles.',
    warnings: 'Advertencias',
    itemsParsed: 'Se procesaron exitosamente {count} artículos:',
    andMore: '...y {count} artículos más',
    validationSummary: 'Resumen de validación',
    duplicateSKUs: 'Se encontraron SKUs duplicados',
    skuFormat: 'El SKU debe contener solo letras, números y guiones',
    quantityRange: 'La cantidad debe estar entre 1 y 9999',
    maxRows: 'Máximo 1000 filas permitidas',
    rowsSkipped: '{count} filas fueron omitidas debido a errores',
    previewTitle: 'Vista previa del pedido',
    previewDescription: 'Revise y edite los datos de su pedido antes de continuar',
    proceedToCart: 'Añadir al carrito',
    // File parsing messages
    fileEmpty: 'El archivo está vacío o no contiene datos',
    fileTooManyRows: 'El archivo contiene demasiadas filas ({current}). Máximo permitido: {max}',
    invalidRowFormat: 'Formato de fila inválido',
    missingColumns: 'Faltan columnas obligatorias (SKU y Cantidad)',
    missingSku: 'Falta el SKU',
    invalidSkuFormat: 'Formato de SKU inválido: "{sku}" (debe coincidir con el patrón: {pattern})',
    skuTooLong: 'SKU demasiado largo: "{sku}" (máximo 50 caracteres)',
    invalidQuantity: 'Cantidad inválida: "{quantity}" no es un número',
    quantityTooLow: 'Cantidad muy baja: {quantity} (mínimo: {min})',
    quantityTooHigh: 'Cantidad muy alta: {quantity} (máximo: {max})',
    notesRequired: 'El campo de notas es obligatorio',
    noValidData: 'No se encontraron datos válidos. Verifique el formato de su archivo.',
    row: 'Fila {row}: {errors}',
    rowErrors: '...y {count} errores más',
    duplicateSkuInRows: 'SKU duplicado "{sku}" encontrado en las filas: {rows}',
    quantityExceedsMax: 'Fila {row}: La cantidad {quantity} excede el máximo permitido ({max})',
    quantityBelowMin: 'Fila {row}: La cantidad {quantity} está por debajo del mínimo requerido ({min})',
    // Validation messages
    unsupportedFileFormat: 'Formato de archivo no compatible. Suba un archivo CSV o Excel.',
    csvParsingErrors: 'Ocurrieron errores al procesar el CSV',
    failedToParseFile: 'Error al procesar el archivo',
    failedToParseExcel: 'Error al procesar el archivo Excel',
    failedToReadFile: 'Error al leer el archivo',
    unknownError: 'Ocurrió un error desconocido',
    totalRows: 'Total de filas',
    valid: 'Válidas',
    invalid: 'Inválidas',
    skipped: 'Omitidas',
    // SKU validation
    skuValidationError: 'Error de validación de SKU',
    skuValidationFailed: 'Error al validar SKUs. Puede continuar pero algunos artículos podrían no estar disponibles.',
    skuNotFound: 'SKU no encontrado en la base de datos',
    skusNotFound: '{count} SKUs no encontrados en la base de datos',
    itemsHaveInsufficientStock: '{count} artículos tienen stock insuficiente',
    validatingSKUs: 'Verificando artículos...',
    unvalidatedChanges: 'Tienes cambios sin validar. Por favor, valida de nuevo antes de añadir al carrito.',
    revalidate: 'Revalidar',
    validating: 'Validando...',
    validationSuccess: 'Todos los artículos son válidos',
    validationComplete: 'Validación completada',
    validationResultSummary: '{errors} errores, {warnings} advertencias encontradas',
    // Table headers
    actions: 'Acciones',
    notes: 'Notas',
    // Status filter
    all: 'Todos',
    hasErrors: 'Con errores',
    // Selection summary
    selected: 'seleccionados',
    errors: 'errores',
    // Pagination
    page: 'Página {current} de {total}',
    previous: 'Anterior',
    next: 'Siguiente',
    noResults: 'Sin resultados.',
    // Cart integration
    noValidItems: 'Sin artículos válidos',
    allItemsHaveErrors: 'Todos los artículos tienen errores de validación. Corríjalos antes de continuar.',
    dataLoadingError: 'Error al cargar datos',
    failedToLoadProductData: 'Error al cargar datos del producto. Intente nuevamente.',
    itemsAddedToCart: '{count} artículos añadidos al carrito',
    itemsAddedMessage: 'Se añadieron {count} artículos al carrito',
    someSkusNotFound: '{count} SKUs no se pudieron encontrar.',
    noItemsAdded: 'Sin artículos añadidos',
    couldNotFindProducts: 'No se encontraron productos que coincidan con los SKUs.',
    errorAddingToCart: 'Error',
    failedToAddToCart: 'Error al añadir artículos al carrito. Intente nuevamente.',
    addingToCart: 'Añadiendo al carrito...',
    // File info
    fileSelected: '{name} seleccionado para procesar',
    fileSize: '{size} bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Descarga de plantilla',
    templateWillBeImplemented: 'La descarga de plantilla se implementará en la Fase 7',
    // Additional validation
    validationFailed: 'La validación falló',
    // Template download
    templateDownloaded: 'Plantilla descargada exitosamente',
    templateDownloadError: 'Error al descargar la plantilla',
    downloadExcelTemplate: 'Descargar plantilla Excel',
    downloadCsvTemplate: 'Descargar plantilla CSV',
    // Template content
    sheetName: 'Pedido masivo',
    instructionsSheetName: 'Instrucciones',
    columnDescriptions: 'Descripción de columnas:',
    columnHeader: 'Columna',
    columnRequired: 'Obligatorio',
    columnOptional: 'Opcional',
    columnDescription: 'Descripción',
    templateNotes: 'Notas:',
    templateNote1: 'La primera fila debe contener los encabezados de columna exactamente como se muestra',
    templateNote2: 'Los datos comienzan desde la fila 2',
    templateNote3: 'El SKU debe coincidir con los códigos de productos existentes en el sistema',
    templateNote4: 'La cantidad debe ser un número entero positivo entre 1 y 9999',
    templateNote5: 'Máximo 1000 filas permitidas por archivo',
    templateNote6: 'Guardar como formato .xlsx o .csv',
    stockAvailabilityWarning: 'La disponibilidad real del stock se verificará en la siguiente página de pago.',
    outOfStock: 'Sin stock',
    insufficientStock: 'Stock insuficiente: {available} disponible, {requested} solicitado',
  },
  orderExport: {
    export: 'Exportar Pedido',
    exportOrder: 'Exportar Datos del Pedido',
    exportAsCSV: 'Exportar como CSV',
    exportAsExcel: 'Exportar como Excel',
    exportForReorder: 'Exportar para Importación Masiva',
    detailed: 'Detalles Completos',
    simpleFormat: 'Formato de Importación',
  },
};